import React from "react";
import { CommunicationMainStyles } from "./styles.module";

import { SideBar } from "../SideBar/SideBar";
import ChatContainer from "../Chat/Chat.Container";
import { SenderList } from "../SenderList/SenderList";
import { Agent, Department } from "../../../models";
import LS from "../../../utils/LocalStorageManager";
import socketTest from "../../../communications/index";
import { WorkspaceList, PartialUser } from "../WorkspaceList/WorkspaceList";
import { StateToProps, DispatchToProps } from "./Main.Container";
import { User } from "../../../communications/states/WorkspacesState";
import { UserCredentials } from "../../../../src/communications/types";

type Props = StateToProps & DispatchToProps;

export class CommunicationMain extends React.Component<Props> {
  state: any = {
    shownWorkspaceList: false,
    // --
    shownSenderList: false,
    savedSenderData: null,
  };

  componentDidMount(): void {
    const sender = LS.getSender();
    if (sender) {
      this.setState({
        savedSenderData: sender,
      });
    }
  }

  removeSender() {
    LS.removeSender();
    this.setState({
      savedSenderData: null,
    });
  }

  saveSender(sender: Department) {
    LS.saveSender(sender);
    this.setState({
      savedSenderData: sender,
    });
  }

  onChangeSender(sender: Department) {
    this.saveSender(sender);
    this.props.changeContactType(this.props.contactType); // reset chat
    socketTest.requestContacts((contacts) => {
      // reload contacts
      this.props.loadTechnicianContacts(contacts);
      this.props.loadCustomerContacts(contacts);
    });
  }

  toggleWorkspaceListShown() {
    this.setState({ shownWorkspaceList: !this.state.shownWorkspaceList });
  }

  toggleSenderListShown() {
    this.setState({ shownSenderList: !this.state.shownSenderList });
  }

  render() {
    const show = true;

    // ${show ? "--visible" : ""}
    return (
      <CommunicationMainStyles className={`${show ? "--visible" : ""}`}>
        <SideBar
          activeTab={this.props.contactType}
          customerMsgCounter={this.props.allCustomerIncomingMessages}
          technicianMsgCounter={this.props.allTechIncomingMessages}
          setActiveTab={this.props.changeContactType}
          backToDashboard={() => this.props.changeChatVisibility()}
          toggleSenderListShown={() => this.toggleSenderListShown()}
          hasAccessToWorkspaces={this.props.hasAccessToWorkspaces}
          toggleWorkspaceListShown={() => this.toggleWorkspaceListShown()}
        />
        <ChatContainer />
        <SenderList
          show={this.state.shownSenderList}
          onHide={() => this.toggleSenderListShown()}
          departments={this.props.departments}
          agent={this.props.agent}
          savedSenderData={this.state.savedSenderData}
          onChangeSender={(selectedSender: Department) =>
            this.onChangeSender(selectedSender)
          }
        />
        <WorkspaceList
          show={this.state.shownWorkspaceList}
          onHide={() => this.toggleWorkspaceListShown()}
          workspaces={this.props.workspaces}
          agent={this.props.agent}
          savedWorkspaceData={this.props.selectedWorkspace}
          onChangeWorkspace={(workspace: User | null) => {
            const viewedWorkspace: UserCredentials | null = workspace
              ? {
                  sid: `${workspace.uid}`,
                  email: workspace.email,
                  token: workspace.token,
                  full_name: workspace.full_name,
                  phone: workspace.phone,
                  departments: workspace.departments,
                }
              : null;

            this.removeSender();
            socketTest.setViewedWorkspace(viewedWorkspace);
            this.props.setSelectedWorkspace(workspace);

            this.props.changeContactType(this.props.contactType); // reset chat
            socketTest.requestContacts((contacts) => {
              // reload contacts
              this.props.loadTechnicianContacts(contacts);
              this.props.loadCustomerContacts(contacts);
            });
          }}
        />
      </CommunicationMainStyles>
    );
  }
}
